import BASE_API from '@/api/dataBase.js';
export const baseForm = (ctx) => {
  return [
    {
      prop: 'contractCreateDate',
      name: '制单日期',
      type: 'date',
      format: 'yyyy-MM-dd',
      disabled: true,
    },
    //合同编号3
    {
      prop: 'contractNo',
      name: '合同编号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'externalContractNo',
      name: '外部合同号',
      type: 'input',
      placeholder: '请输入外部合同号',
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
      maxlength: 100,
    },
    {
      prop: 'contractType',
      name: '合同类别',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'serviceContractType' },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'companyCode',
      name: '公司',
      type: 'select',
      label: 'personCompanyName',
      value: 'personCompanyCode',
      options: ctx.companyList || [],
      changeMethod: 'changeMethod',
    },
    {
      prop: 'departmentCode',
      name: '业务部门',
      type: 'select',
      label: 'label',
      value: 'value',
      options: ctx.departmentList || [],
      changeMethod: 'changeMethod',
    },
    {
      prop: 'projectInitiationNo',
      name: '项目编号',
      searchType: 'projectListWumao',
      type: 'searchTableSpec',
      isMultiple: true,
      currentValue: ctx.baseFormData?.projectInitiationNo
        ? ctx.baseFormData?.projectInitiationNo
        : null,
      checkRowKeys: [
        ctx.baseFormData.projectInitiationNo ? ctx.baseFormData.projectInitiationNo : null,
      ],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        platformtCompany: ctx.baseFormData.companyCode,
        platformtCompanyName: ctx.baseFormData.companyName,
        applyCompanyNo: ctx.baseFormData.companyCode,
        applyCompanyName: ctx.baseFormData.companyName,
        // applyDepartmentName: ctx.baseFormData.departmentName,
      },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
      disabled: true,
      placeholder: '请输入项目名称',
    },
    {
      prop: 'platformCompanyFileNo',
      name: '平台公司',
      type: 'select',
      options: ctx.platformCompanyFileList,
      changeMethod: 'changeMethod',
      placeholder: '请选择平台公司',
      disabled: !ctx.baseFormData.projectInitiationNo,
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05',
    },
    {
      prop: 'platformCompanyFileNo',
      name: '平台公司档案编号',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'supplierNo',
      name: '供应商名称',
      type: 'searchTableSpec',
      searchType: 'supplier',
      extraData: {
        partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
        departmentCode: ctx.baseFormData.departmentCode, //部门
        companyCode: ctx.baseFormData.companyCode, //公司
      },
      currentValue: ctx.baseFormData.supplierName ? ctx.baseFormData.supplierName : null,
      checkRowKeys: [ctx.baseFormData.supplierNo ? ctx.baseFormData.supplierNo : null],
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'signDate',
      name: '合同签署日期',
      type: 'date',
      format: 'yyyy-MM-dd',
    },
    {
      prop: 'contractValidStart',
      name: '合同生效日期',
      type: 'startDaterangePicker',
      format: 'yyyy-MM-dd',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractValidEnd',
      name: '合同到期日期',
      type: 'endDaterangePicker',
      format: 'yyyy-MM-dd',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'isNotEndDate',
      name: '至合同履行截止日止',
      labelPosition: 'right',
      falseLable: '0',
      trueLable: '1',
      type: 'checkbox',
    },
    {
      prop: 'isDefault',
      name: '有无违约责任标识',
      labelPosition: 'right',
      type: 'checkbox',
      falseLable: '0',
      trueLable: '1',
      changeMethod: 'changeMethod',
    },
    {
      type: 'dict',
      dictType: 'liquidatedDamages',
      name: '合同违约金类型',
      prop: 'liquidatedDamagesType',
      disabled: ctx.disabledFieldList.includes('liquidatedDamagesType'),
      changeMethod: 'changeMethod',
      placeholder: '请选择',
    },
    {
      prop: 'liquidatedFixedValue',
      name: '违约金固定值',
      type: 'input',
      placeholder: '请输入违约金固定值',
      disabled: ctx.disabledFieldList.includes('liquidatedFixedValue'),
    },
    {
      prop: 'liquidatedInterestRate',
      name: '违约金日利率',
      type: 'inputNumber',
      placeholder: '请输入违约金日利率',
      append: '%',
      disabled: ctx.disabledFieldList.includes('liquidatedInterestRate'),
    },
    // {
    //   prop: 'creditAmount',
    //   name: '预付金额',
    //   type: 'inputNumber',
    //   placeholder: '请输入预付金额',
    //   disabled: ctx.baseFormData.isPrepay == '0' || !ctx.baseFormData.isPrepay,
    // },
    {
      prop: 'isFixedPrice',
      name: '不定价',
      type: 'checkbox',
      labelPosition: 'right',
      falseLable: '0',
      trueLable: '1',
      disabled: true,
    },
    {
      prop: 'pricingRule',
      name: '定价模式',
      type: 'ajaxSelect',
      clearable: true,
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'pricing_rule' },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'marginAmount',
      name: '保证金',
      type: 'input',
    },
    {
      prop: 'businessType',
      name: '业务性质',
      type: 'ajaxSelect',
      clearable: false,
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'purchase_business_type' },
      placeholder: '请选择业务性质',
    },
    {
      prop: 'receiptMethod',
      name: '付款方式',
      type: 'select',
      options: ctx.dictListMap?.apply_payment_method || [],
      changeMethod: 'changeMethod',
    },
    {
      name: '货币',
      prop: 'companyCurrency',
      type: 'select',
      options: ctx.currencyList,
      changeMethod: 'changeMethod',
    },

    {
      prop: 'overShippedPercentage',
      name: '溢装比例',
      type: 'inputNumber',
      append: '%',
    },

    {
      prop: 'shortShippedPercentage',
      name: '短装比例',
      type: 'inputNumber',
      append: '%',
    },
    {
      prop: 'lastestReceiveProductDay',
      name: '最晚收货日',
      type: 'date',
      format: 'yyyy-MM-dd',
      placeholder: '请选择最晚收货日',
    },
    {
      prop: 'lastestPayMoneyDay',
      name: '最晚付款日',
      type: 'date',
      format: 'yyyy-MM-dd',
      placeholder: '请选择最晚付款日',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1 * 24 * 60 * 60 * 1000;
        },
      },
    },
    {
      prop: 'incomeMethod',
      name: '收益方式',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'incomeMethod' },
      type: 'ajaxSelect',
      placeholder: '请选择收益方式',
    },
    {
      prop: 'isRestrict',
      name: '是否定量',
      type: 'select',
      options: [
        {
          value: '0',
          label: '否',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      changeMethod: 'changeMethod',
    },
    {
      prop: 'isLongRange',
      name: '是否长期合同',
      type: 'select',
      options: [
        {
          value: '0',
          label: '否',
        },
        {
          value: '1',
          label: '是',
        },
      ],
    },
    {
      prop: 'contractOperaterName',
      name: '操作人',
      type: 'input',
      disabled: true,
    },
  ];
};

export const baseFormRule = () => {
  return {
    projectInitiationNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    projectName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    supplierNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    // contractNo: [{ required: true, message: '必填字段', trigger: 'blur' }],
    departmentCode: [{ required: true, message: '必填字段', trigger: 'blur' }],
    companyCode: [{ required: true, message: '必填字段', trigger: 'blur' }],
    contractCreateDate: [{ required: true, message: '必填字段', trigger: 'blur' }],
    contractOperaterName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    contractName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    platformCompanyFileNo: [{ required: true, message: '必填字段', trigger: 'blur' }],
  };
};
